import styled from "react-emotion"
import PropTypes from "prop-types"

const Heading = styled("p")`
    font-size: ${props =>
        props.theme[
            (props.size === "small" && "headingThreeSize") ||
                (props.size === "medium" && "headingTwoSize") ||
                (props.size === "large" && "headingOneSize") ||
                "headingOneSize"
        ]};
    color: ${props => props.theme.headingColor};
    font-weight: ${props => props.theme.headingWeight};
    font-family: ${props => props.theme.headingFont};
    margin: ${props => props.theme.small} 0px;
    padding: ${props => props.theme[props.padding || "medium"]} 0px;
    margin: ${props => props.theme[props.margin || "small"]} 0px;
    line-height: 1em;
    ${props =>
        props.inline &&
        `
        display: inline-block;
    `};
    ${props =>
        props.light &&
        `
        color: ${props.theme.lightFontColor};
    `};
`

Heading.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    margin: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    size: PropTypes.oneOf(["small", "medium", "large"]),
    inline: PropTypes.bool,
    light: PropTypes.bool,
}

Heading.displayName = "Heading"
export default Heading



// WEBPACK FOOTER //
// ./src/ui/components/Heading.js